import { useState } from 'react';
import { Link } from 'react-router-dom';
import { news } from '@/mocks/news';

type Tab = 'latest' | 'hot';

export default function LatestNews() {
  const [tab, setTab] = useState<Tab>('latest');

  const sorted = [...news].sort((a, b) => {
    if (tab === 'latest') return b.date.localeCompare(a.date);
    return b.views - a.views;
  });
  const list = sorted.slice(0, 5);

  return (
    <section className="w-full bg-background-100">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <span className="text-xs tracking-[0.25em] text-accent-600">LATEST NEWS</span>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">最新动态快讯</h2>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center bg-background-50 border border-background-200 rounded-full px-1 py-1">
              <button
                type="button"
                onClick={() => setTab('latest')}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  tab === 'latest' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                最新
              </button>
              <button
                type="button"
                onClick={() => setTab('hot')}
                className={`px-4 py-1.5 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap ${
                  tab === 'hot' ? 'bg-primary-500 text-background-50' : 'text-foreground-600 hover:text-primary-600'
                }`}
              >
                最热
              </button>
            </div>
            <Link
              to="/category/news"
              className="hidden md:inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              全部动态
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-6">
          {list[0] && (
            <Link
              to={`/detail/news/${list[0].id}`}
              className="group block rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <div className="w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={list[0].thumbnail}
                  alt={`${list[0].title} 配图`}
                  title={`${list[0].title} 小仓优子最新动态`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 text-xs mb-2">
                  <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900">{list[0].category}</span>
                  <span className="text-foreground-500">{list[0].date}</span>
                </div>
                <h3 className="font-heading text-lg md:text-xl text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {list[0].title}
                </h3>
                <p className="text-sm text-foreground-600 mt-2 line-clamp-2">{list[0].summary}</p>
              </div>
            </Link>
          )}

          <div className="flex flex-col gap-3">
            {list.slice(1).map((item) => (
              <Link
                key={item.id}
                to={`/detail/news/${item.id}`}
                className="group flex items-start gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
              >
                <span className="w-8 h-8 flex-shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-sm">
                  {item.id}
                </span>
                <div className="flex-1 min-w-0">
                  <h4 className="font-heading text-base text-foreground-900 group-hover:text-accent-600 transition-colors line-clamp-2">
                    {item.title}
                  </h4>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 mt-2">
                    <span>{item.date}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.views.toLocaleString()}
                    </span>
                  </div>
                </div>
                <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-accent-500 transition-colors mt-1"></i>
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-6 md:hidden">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部动态
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}